import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MessageDropdown from 'components/navbar/top/MessageDropdown';
import NotificationDropdown from 'components/navbar/top/NotificationDropdown';
import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import AppContext from 'context/Context';
import React, { useContext } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAuth } from 'context/AuthContext';
import NineDotMenu from './NineDotMenu';

const TopNavRightSideNavItem = () => {
  const { hasAnyPermission } = useAuth();
  const {
    config: { isDark, isRTL },
    setConfig
  } = useContext(AppContext);
  const canViewNotifications = hasAnyPermission([
    'notifications.view_internal',
    'notifications.view_mercadolibre',
    'notifications.view_questions'
  ]);
  const canViewMessages = hasAnyPermission([
    'messages.view_internal',
    'messages.view_mercadolibre'
  ]);
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <Nav.Item as={'li'}>
        <Nav.Link
          className="px-2 theme-control-toggle"
          onClick={() => setConfig('isDark', !isDark)}
        >
          <OverlayTrigger
            key="left"
            placement={isRTL ? 'bottom' : 'left'}
            overlay={
              <Tooltip style={{ position: 'fixed' }} id="ThemeColor">
                {isDark ? 'Switch to light theme' : 'Switch to dark theme'}
              </Tooltip>
            }
          >
            <div className="theme-control-toggle-label">
              <FontAwesomeIcon
                icon={isDark ? 'sun' : 'moon'}
                className="fs-0"
              />
            </div>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item>

      {canViewMessages ? <MessageDropdown /> : null}
      {canViewNotifications ? <NotificationDropdown /> : null}
      <NineDotMenu />
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
